module.exports = __webpack_public_path__ + "img/pp1.4acb450c.png";